import { AggregationMode } from '../index';
import { InterpolationType } from '../../common';
import { Helper } from '../../common/helpers/helper';

export class Shape {
    guid: string;
    name: string;

    color: string;
    symbol: string;
    isSymbolVisible: boolean;
    isLineVisible: boolean;
    points: ShapePoint[];
    isClosed: boolean;
    isFilled: boolean;
    thickness: number; //thin/medium/thick?
    aggregationMode: AggregationMode;
    // aggregation: aggregationConfiguration;
    // minPeriod: timeInterval;
    // maxPeriod: timeInterval;
    interpolation: InterpolationType;

    constructor(name: string, color: string) {
        this.aggregationMode = AggregationMode.Average;
        this.guid = Helper.getGuid();
        this.name = name;
        this.color = color;
        this.thickness = 1;
        this.interpolation = 'linear-closed';
        this.symbol = 'circle';
        this.isLineVisible = true;
    }
}

export type ShapePointType = 'manual' | 'serie';

export class ShapePoint {
    guid: string;
    x: ShapePointReference;
    y: ShapePointReference;
    constructor() {
        this.guid = Helper.getGuid();
        this.x = new ShapePointReference();
        this.y = new ShapePointReference();
    }
}
export class ShapePointReference {
    type: ShapePointType;
    seriesGuid: string;
    isBoundToGroup: boolean;
    value?: number;
    valueType?: string;
    constructor() {
        this.type = 'manual';
    }
}